import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../modules/auth-core/data/service/authentication.service';
import { Log } from '../log';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private authService: AuthenticationService, private router: Router) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        Log.debug(next, state);
        if  (this.authService.token == null) {
            localStorage.setItem('sessinvalid', '1');
            this.router.navigateByUrl(`/auth/login`);
            return false;
        }
        return true;
    }
}
